import React from "react"
import { Controller } from "react-hook-form"
// components
import { Button } from "@components/Button"
import { InputWithLabel } from "@components/Form"
import { useSelector } from "react-redux"
// assets

const MedicalInfo = ({ control, errors, setShowClickedButton }) => {
  const { isAddPatientLoading } = useSelector((stat) => stat.patient)
  const currentFormField = [
    "eye",
    "firstName",
    "lastName",
    "country",
    "province",
    "pincode",
    "address",
    "contact",
    "email",
  ]

  const currentFormErrors = Object.keys(errors).filter((key) =>
    currentFormField.includes(key)
  )

  const isButtonDisabled = Object.keys(currentFormErrors)?.length > 0

  return (
    <>
      <div className="w-full md:max-w-[21.87rem] gap-4 flex flex-col">
        <div className="gap-4 flex flex-col bg-[--pure-white] p-4 md:p-0 rounded-2xl border border-[--border-theme-300] md:border-0">
          <h2 className="text-xs font-medium text-[--text-light-gray]">
            MEDICAL INFO
          </h2>
          <InputWithLabel
            label="Eye"
            name="eye"
            rules={{
              required: "eye is required",
            }}
            type="text"
            control={control}
            errors={errors}
            customInput={
              <div className="relative flex items-center rounded-md">
                <Controller
                  control={control}
                  name="eye"
                  rules={{
                    required: "eye is required",
                  }}
                  render={({ field: { value, onChange, ref } }) => (
                    <div className="flex items-center w-full border border-[var(--border-secondary)] rounded-lg bg-[#EFF0F0]">
                      <div className="flex items-center w-1/3 gap-2 py-2.5 px-6 border-r">
                        <input
                          type="radio"
                          id="male"
                          name="eye"
                          value="left"
                          onChange={onChange}
                          ref={ref}
                          className="h-4 w-4"
                          checked={value === "left"}
                          disabled
                        />
                        <label
                          className="text-sm font-bold text-[#344054]"
                          htmlFor="male"
                        >
                          left
                        </label>
                      </div>

                      <div className="flex items-center w-1/3 gap-2 py-2.5 px-6 border-r">
                        <input
                          type="radio"
                          id="female"
                          name="eye"
                          value="right"
                          onChange={onChange}
                          ref={ref}
                          className="h-4 w-4"
                          checked={value === "right"}
                          disabled
                        />
                        <label
                          className="text-sm font-bold text-[#344054]"
                          htmlFor="female"
                        >
                          right
                        </label>
                      </div>
                      <div className="flex items-center w-1/3 gap-2 py-2.5 px-6">
                        <input
                          type="radio"
                          id="others"
                          name="eye"
                          value="both"
                          onChange={onChange}
                          ref={ref}
                          className="h-4 w-4"
                          checked={value === "both"}
                          disabled
                        />
                        <label
                          className="text-sm font-bold text-[#344054]"
                          htmlFor="others"
                        >
                          both
                        </label>
                      </div>
                    </div>
                  )}
                />
              </div>
            }
            isRequired
          />
        </div>
        <div className="gap-4 flex flex-col bg-[--pure-white] p-4 md:p-0 rounded-2xl border border-[--border-theme-300] md:border-0">
          <Button
            variant="primary"
            type="submit"
            size="md"
            className={`font-medium ${isButtonDisabled ? "!bg-[#BCBEC0]" : ""} text-[--pure-white]`}
            loading={isAddPatientLoading}
            disabled={isButtonDisabled}
            onClick={() => {
              setShowClickedButton("save")
            }}
          >
            SAVE
          </Button>
          <div className="flex flex-col gap-2 items-center">
            <Button
              variant="transparent"
              className="text-[--primary-blue] border border-[--border-secondary] !font-bold w-full"
              type="submit"
              size="md"
              disabled={isButtonDisabled}
              loading={isAddPatientLoading}
              onClick={() => {
                setShowClickedButton("save and proceed to plan")
              }}
            >
              SAVE AND PROCEED TO PLAN
            </Button>
            <div className="text-xs text-[--text-light-gray]">
              You can select the plan later from patient detail
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MedicalInfo
